import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import { useTranslation } from "../../../localization/useTranslation";
import { SwitchNumbersCount, TasksWidgetProps } from "../../tasksWidget/TaskWidget";
import Widget from "../../Widget";
import TasksWidgetStatus from "../../tasksWidget/tasksWidgetStatus/TasksWidgetStatus";
import TasksWidgetReportTask from "./tasksWidgetReportTask/TasksWidgetReportTask";
import TaskWidgetEmptyState from "../../tasksWidget/taskWidgetEmptyState/TaskWidgetEmptyState";
import { useTasksWidget } from "../../tasksWidget/TaskWidget.hooks";
import { tasksWidgetStyles } from "../../tasksWidget/TaskWidget.styles";

function TasksWidgetReport(props: TasksWidgetProps) {
    const { translateString } = useTranslation();

    const { tasks, progress, isEnabled, numberOfOverdueTasks, numberOfTasksThisMonth, noOverdueTaskStreakInMonths } = useTasksWidget(props);

    return (
        <Widget disabled={!isEnabled} isPdf>
            <Box sx={tasksWidgetStyles.content}>
                <Box>
                    <DotLegalHeader headerStyle={"medium"} marginBottom={0}>
                        {translateString("tasks").toUpperCase()}
                    </DotLegalHeader>
                    <DotLegalHeader headerStyle={"small"} marginBottom={0}>
                        <>
                            {props.showCurrentMonth ? translateString("thisMonth") : translateString("overdueTask")}
                            <SwitchNumbersCount>{props.showCurrentMonth ? numberOfTasksThisMonth : numberOfOverdueTasks}</SwitchNumbersCount>
                        </>
                    </DotLegalHeader>
                </Box>
                <TasksWidgetStatus progress={progress} numberOfTasks={tasks.length} showCurrentMonth={props.showCurrentMonth ?? false} />

                {tasks.length > 0 ? (
                    <Box sx={tasksWidgetStyles.list}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pr: 2 }}>
                            {tasks.map((task) => {
                                return (
                                    <TasksWidgetReportTask
                                        activityName={task.name}
                                        taskName={task.processingActivityName ?? ""}
                                        responsibles={task.responsibles}
                                        deadline={task.deadline}
                                        subTaskCompleted={task.completedSubTasks}
                                        totalSubTasks={task.totalSubTasks}
                                        taskStatus={task.laneState}
                                        isOverdue={task.isOverdue}
                                        priority={task.priority}
                                        customId={task.customId}
                                        isReadyForApproval={task.isReadyForApproval}
                                        isAdhocTask={task.isAdHocTask}
                                        evaluationStatus={task.evaluationStatus}
                                        taskId={task.id}
                                        key={task.id}
                                    />
                                );
                            })}
                        </Box>
                    </Box>
                ) : (
                    <TaskWidgetEmptyState showCurrentMonth={props.showCurrentMonth ?? false} noOverdueTaskStreakInMonths={noOverdueTaskStreakInMonths} />
                )}
            </Box>
        </Widget>
    );
}

export default TasksWidgetReport;
